var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27387 4.30298C1.40981 5.42717 0.758277 6.72289 0.378906 8.13051H6.1014L2.27387 4.30298Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6208 8.13059C21.2415 6.72301 20.5899 5.42729 19.7259 4.3031L15.8984 8.13059H21.6208Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.378906 13.8695C0.75832 15.2771 1.40986 16.5728 2.27387 17.6969L6.10127 13.8695H0.378906Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6966 2.27391C16.5724 1.40986 15.2768 0.75832 13.8691 0.378906V6.10136L17.6966 2.27391Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30273 19.7261C5.42693 20.5901 6.72265 21.2417 8.13022 21.6211V15.8987L4.30273 19.7261Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13018 0.378906C6.72261 0.75832 5.42688 1.40986 4.30273 2.27387L8.13018 6.10131V0.378906Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 21.6211C15.2767 21.2417 16.5724 20.5901 17.6966 19.7261L13.8691 15.8987V21.6211Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 13.8695L19.7259 17.697C20.5899 16.5728 21.2415 15.2771 21.6208 13.8695H15.8984Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9069 9.56523H12.4349H12.4348V0.0931133C11.9651 0.0319688 11.4863 0 11 0C10.5136 0 10.0349 0.0319688 9.56523 0.0931133V9.56514V9.56519H0.0931133C0.0319688 10.0349 0 10.5137 0 11C0 11.4864 0.0319688 11.9651 0.0931133 12.4348H9.56514H9.56519V21.9069C10.0349 21.968 10.5136 22 11 22C11.4863 22 11.9651 21.9681 12.4348 21.9069V12.4349V12.4348H21.9069C21.968 11.9651 22 11.4864 22 11C22 10.5137 21.968 10.0349 21.9069 9.56523Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 13.8697L18.7777 18.7782C19.0035 18.5526 19.2188 18.3166 19.4243 18.0721L15.2219 13.8696H13.8691V13.8697Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1303 13.8696H8.13021L3.22168 18.7782C3.44735 19.0039 3.68329 19.2193 3.92787 19.4248L8.1303 15.2222V13.8696Z",
    fill: "#D80027"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13037 8.13051V8.13042L3.22179 3.2218C2.99603 3.44747 2.78067 3.68341 2.5752 3.92799L6.77767 8.13047L8.13037 8.13051Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 8.13053L18.7778 3.22187C18.5521 2.99611 18.3161 2.78075 18.0716 2.57532L13.8691 6.77779V8.13053Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.3a7015b6343f5b97009c28699ceacee1.svg";
export { ForwardRef as ReactComponent };